import { useMemo } from 'react';

import { IOverviewReportSummaryData } from 'schemas';

interface IUseSummaryValuesReturn {
  getValue: (title: string, mod?: boolean) => string | number;
  getExtraValue: (title: string) => string | number | null;
  depositFillPercent: number;
}
export const useSummaryValues = (
  data: IOverviewReportSummaryData[] | undefined,
  loading: boolean
): IUseSummaryValuesReturn => {
  const getValue = (title: string, mod?: boolean): string | number => {
    if (loading) return '—';
    const value = data?.find((item) => item.title === title)?.value;
    return value !== undefined ? value : mod ? '0' : '—';
  };
  const getExtraValue = (title: string): string | number | null => {
    if (loading) return '—';
    const value = data?.find((item) => item.title === title)?.extraValue;
    return value !== undefined ? value : 0;
  };

  const getNumericValue = (title: string): number => {
    const value = data?.find((item) => item.title === title)?.value;
    return Number(value) || 0;
  };

  const depositFillPercent = useMemo(() => {
    const total = getNumericValue('total_revenue');
    return total
      ? parseFloat(
          ((getNumericValue('deposit_revenue') / total) * 100).toFixed(1)
        )
      : 0;
  }, [data]);

  return { getValue, getExtraValue, depositFillPercent };
};

export const formatMoney = (m: number | string | null, cur?: string): string =>
  `${m?.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${
    cur ? cur : ''
  }`;
